import { SelectedWeekDaysType } from './types'

export enum WeekdaysKeys {
  Monday = '0',
  Tuesday = '1',
  Wednesday = '2',
  Thursday = '3',
  Friday = '4',
  Saturday = '5',
  Sunday = '6',
}

export enum WeekdaysKeysBackend {
  Sunday = '0',
  Monday = '1',
  Tuesday = '2',
  Wednesday = '3',
  Thursday = '4',
  Friday = '5',
  Saturday = '6',
}

export const WEEKDAYS_LABELS: Record<WeekdaysKeys, string> = {
  [WeekdaysKeys.Monday]: 'global.day_of_week.monday',
  [WeekdaysKeys.Tuesday]: 'global.day_of_week.tuesday',
  [WeekdaysKeys.Wednesday]: 'global.day_of_week.wednesday',
  [WeekdaysKeys.Thursday]: 'global.day_of_week.thursday',
  [WeekdaysKeys.Friday]: 'global.day_of_week.friday',
  [WeekdaysKeys.Saturday]: 'global.day_of_week.saturday',
  [WeekdaysKeys.Sunday]: 'global.day_of_week.sunday',
}

export const WEEKDAYS_KEYS_FOR_BACKEND: Record<WeekdaysKeys, WeekdaysKeysBackend> = {
  [WeekdaysKeys.Sunday]: WeekdaysKeysBackend.Sunday,
  [WeekdaysKeys.Monday]: WeekdaysKeysBackend.Monday,
  [WeekdaysKeys.Tuesday]: WeekdaysKeysBackend.Tuesday,
  [WeekdaysKeys.Wednesday]: WeekdaysKeysBackend.Wednesday,
  [WeekdaysKeys.Thursday]: WeekdaysKeysBackend.Thursday,
  [WeekdaysKeys.Friday]: WeekdaysKeysBackend.Friday,
  [WeekdaysKeys.Saturday]: WeekdaysKeysBackend.Saturday,
}

export const WEEKDAYS_KEYS_FOR_FRONTEND: Record<WeekdaysKeysBackend, WeekdaysKeys> = {
  [WeekdaysKeysBackend.Sunday]: WeekdaysKeys.Sunday,
  [WeekdaysKeysBackend.Monday]: WeekdaysKeys.Monday,
  [WeekdaysKeysBackend.Tuesday]: WeekdaysKeys.Tuesday,
  [WeekdaysKeysBackend.Wednesday]: WeekdaysKeys.Wednesday,
  [WeekdaysKeysBackend.Thursday]: WeekdaysKeys.Thursday,
  [WeekdaysKeysBackend.Friday]: WeekdaysKeys.Friday,
  [WeekdaysKeysBackend.Saturday]: WeekdaysKeys.Saturday,
}

export const INTITIAL_SELECTED_WEEKDAYS_STATE = Object.entries(WeekdaysKeys).reduce(
  (summary, [_, weekKey]) => ({
    ...summary,
    [weekKey]: true,
  }),
  {},
) as SelectedWeekDaysType
